import React, { useEffect, useState } from "react";
import ListItem from "@material-ui/core/ListItem";
import { withStyles } from "@material-ui/core/styles";
import { Divider } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { List, Box } from "@material-ui/core";
import InputBase from "@material-ui/core/InputBase";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import {
  updateMileage,
  updatePricingHistory,
  getClearfaxStatusByVin,
  getReasonForUpdateMileage,
  getInspectionVehicleDetails
} from "../service/api";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import Alert from "@material-ui/lab/Alert";
import CheckIcon from "@material-ui/icons/Check";
import ViewFullPricingHistory from "./ViewFullPricingHistory";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';
import NumberFormat from 'react-number-format';

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: "#ffffff",
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "100%",
    height: "10px",
    padding: "10px 12px",
    "&:focus": {
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="$"
    />
  );
});

export default function UpdateMileagePricing(props) {
  const vin = props?.vin;
  const [clearFixStatus, setClearFixStatus] = useState(null);
  const [updateStatus, setUpdateStatus] = useState(null);
  const [updatePricingStatus, setUpdatePricingStatus] = useState(null);
  const [condionVehicleDetails, setCondionVehicleDetails] = React.useState({}); // inspectiondata
  const [isLoading, setIsloading] = useState(false)
  const [updateMileageReason, setUpdateMileageReason] = useState([]);
  const [userUpdateMileageReason, setUserUpdateMileageReason] = useState('');
  const [hideCheckBox, setHideCheckBox] = useState(false);
  const [ViewFullPricingHistoryPop, setViewFullPricingHistoryPop] = useState(false);
  const [InspectionVehicleDetails, setInspectionVehicleDetails] = useState(null)
  const [otherReasonError, setOtherReasonError] = useState(false);
  const [updateMileageErrorMessage, setUpdateMileageErrorMessage] = useState('');
  const [updatePricingErrorMessage, setUpdatePricingErrorMessage] = useState('');
  const [isCompanyCar, setIsCompanyCar] = useState(false);

  const milesFormatter = new Intl.NumberFormat('en-US');

  useEffect(() => {
    getClearfaxStatus();
    getUpdateMileageReason();
    getInspectionVehicleDeta()
  }, [vin]);

  useEffect(() => {
    setCondionVehicleDetails(props.condionVehicleDetails);
  }, [props?.condionVehicleDetails]);

  async function getClearfaxStatus() {
    let apiResponse = await getClearfaxStatusByVin(vin);
    setIsloading(true)
    if (apiResponse && apiResponse?.data) {
      setClearFixStatus(apiResponse?.data);
    }
  }
  const initialMileageForm = {
    groundingMileage: null,
    confirmGroundingMileage: null,
    reasonForUpdate: null,
    hasErr: false,
  };
  const [mileageForm, setMileageForm] = useState(initialMileageForm);
  const initialVehiclePriceForm = {
    vehicle_price: null,
    confirm_vehicle_price: null,
    MMR: null,
    hasErr: false,
    isMMRRequired: false,
  }
  const [vehiclePriceForm, setVehiclePriceForm] = useState(initialVehiclePriceForm);

  const handleOnChangeMileage = (event) => {
    if (event.target.name === "confirmGroundingMileage") {
      setMileageForm({
        ...mileageForm,
        ...{ [event.target.name]: event.target.value, hasErr: true },
      });
    } else {
      setMileageForm({
        ...mileageForm,
        ...{ [event.target.name]: event.target.value },
      });
    }
    if (event?.target?.name === 'otherReason') {
      if (event?.target?.value) {
        setOtherReasonError(false);
      } else {
        setOtherReasonError(true);
      }
    }
  };

  const handleUpdateReason = (event) => {
    setUserUpdateMileageReason(event?.target?.value ? event.target.value : '');
    if (event?.target?.value === 'Other') {
      setOtherReasonError(true);
      mileageForm.otherReason = '';
      setMileageForm({
        ...mileageForm,
        ...{ [event.target.name]: event.target.value },
      });
    } else {
      delete mileageForm.otherReason;
      setOtherReasonError(false);
      setMileageForm({
        ...mileageForm,
        ...{ [event.target.name]: event.target.value },
      });
    }
  }

  const handleOnChangeVehiclePrice = (event) => {
    const mmrValue = event?.target?.value?.length > 0 ? false : true;
    setVehiclePriceForm({
      ...vehiclePriceForm,
      ...{ [event?.target?.name]: event?.target?.value, isMMRRequired: mmrValue },
    });
  };

  const handleOnReEnterChangeVehiclePrice = (event) => {
    const hasErrorvalue = (vehiclePriceForm?.confirm_vehicle_price !== null && vehiclePriceForm?.vehicle_price === event?.target?.value) ? false : true;
    const mmrValue = vehiclePriceForm?.MMR?.length > 0 ? false : true;
    setVehiclePriceForm({
      ...vehiclePriceForm,
      ...{ confirm_vehicle_price: event?.target?.value, hasErr: hasErrorvalue, isMMRRequired: mmrValue },
    });
  };


  const updateDetails = () => {
    mileageForm.groundingMileage && !mileageFormError && doUpdateMileage();
    vehiclePriceForm.vehicle_price && !vehiclePriceFormError && doUpdateVehiclePrice();
    setTimeout(() => {
      setUpdateStatus(null);
      setUpdatePricingStatus(null);
    }, 4000);
  };

  const doUpdateMileage = () => {
    if (mileageForm.groundingMileage === mileageForm.confirmGroundingMileage) {
      var updateMileageType = {
        adjustedBy: "adjustedBy",
        adjMileage: parseInt(mileageForm.groundingMileage),
        reasonForUpdate: mileageForm.reasonForUpdate,
        vin: vin,
      };
      if (mileageForm.otherComment) updateMileageType.otherComment = mileageForm.otherReason
      updateMileage(updateMileageType).then((res) => {
        console.log("updateMileage", res);
        if (res?.data?.status === "Success" || res?.data === "Mileage Update Success" || res === "Mileage Update Success") {
          setUpdateStatus(true);
          resetForm(true, false);
          getInspectionVehicleDeta()
        } else {
          if (res?.status === 299) {
            setUpdateMileageErrorMessage(res?.data?.errorMessages)
          } else {
            setUpdateMileageErrorMessage('Mileage updating failed!')
          }
          setUpdateStatus(false);
        }
      });
    } else {
      console.log(
        "Grounding Mileage and Confirm Grounding Mileage is not match"
      );
    }
  };

  const doUpdateVehiclePrice = () => {
    if (
      vehiclePriceForm.vehicle_price === vehiclePriceForm.confirm_vehicle_price
    ) {
      var updatePricingHistoryType = {
        priceMethod: "Manual",
        providerName: "test user",
        vehicle_price: vehiclePriceForm.vehicle_price,
        MMR: vehiclePriceForm.MMR,
        vin: vin,
      };

      updatePricingHistory(updatePricingHistoryType).then((res) => {
        console.log("updatePricingHistory", res, res?.status, res?.status === 299);
        if (res?.status === 200) {
          resetForm(false, true);
          setUpdatePricingStatus(true);
        } else {
          if (res?.status === 299) {
            setUpdatePricingErrorMessage(res?.data?.errorMessages)
          } else {
            setUpdatePricingErrorMessage('Mileage updating failed!')
          }
          setUpdatePricingStatus(false);
        }
      });
    } else {
      console.log("Vehicle Price and Confirm Vehicle Price is not match");
    }
  };

  async function getUpdateMileageReason() {
    let apiResponse = await getReasonForUpdateMileage();
    setIsloading(true)
    if (apiResponse && apiResponse?.data) {
      setUpdateMileageReason(apiResponse?.data);
    }
  }

  const updateCheckBox = (value) => {
    setHideCheckBox(value)
  }

  const resetForm = (mileageReset, vehiclePriceReset) => {
    if (mileageReset) {
      setOtherReasonError(false)
      setMileageForm({ ...initialMileageForm });
      setUserUpdateMileageReason('');
      Object.keys(mileageForm).forEach(item => {
        if (document?.getElementsByName(item)[0]) {
          document.getElementsByName(item)[0].value = null;
        }
      })
    }

    if (vehiclePriceReset) {
      setVehiclePriceForm({ ...initialVehiclePriceForm });
      Object.keys(vehiclePriceForm).forEach(item => {
        if (document?.getElementsByName(item)[0]) {
          setVehiclePriceForm({
            ...vehiclePriceForm,
            ...{ vehicle_price: '', confirm_vehicle_price: '', MMR: '' },
          })
        }
      })
    }
  }

  async function getInspectionVehicleDeta() {
    let apiResponse = await getInspectionVehicleDetails(vin);
    console.log("getInspectionVehicleDeta==>", apiResponse);
    if (apiResponse && apiResponse?.data) {
      setInspectionVehicleDetails(apiResponse?.data);
      if (apiResponse?.data?.account_type.toLowerCase() === 'company car'){
        setIsCompanyCar(true);
      }
    }
  }

  const priceUpdate = (event) => {
    const hasErrorvalue = (vehiclePriceForm?.vehicle_price !== null && vehiclePriceForm?.vehicle_price === event?.target?.value) ? false : true;
    const mmrValue = vehiclePriceForm?.MMR?.length > 0 ? false : true;
    setVehiclePriceForm({
      ...vehiclePriceForm,
      ...{ vehicle_price: event?.target?.value, hasErr: hasErrorvalue, isMMRRequired: mmrValue },
    })
  }
  let mileageFormError = false;
  let vehiclePriceFormError = false;
  let submitButtonValue = true;
  Object.keys(mileageForm).forEach(item => {
    if (mileageForm[item] === null || mileageForm[item] === '') {
      mileageFormError = true;
    }
  })
  Object.keys(vehiclePriceForm).forEach(item => {
    if (vehiclePriceForm[item] === null || vehiclePriceForm[item] === '' || vehiclePriceForm.vehicle_price !== vehiclePriceForm.confirm_vehicle_price) {
      vehiclePriceFormError = true;
    }
  })
  if (!mileageFormError || !vehiclePriceFormError) {
    submitButtonValue = false
  } else {
    submitButtonValue = true
  }

  const submitButtonStyle = !submitButtonValue ? 'updateButton' : '';

  return (
    <div className={isLoading ? "updatePricingSidebar" : ""}>
      <ListItem className="notesSectionHeader">
        {props.hidden === "Pricing" ? "Update Mileage" : (props.hidden === "Mileage" ? "Update Pricing" : "Update Mileage/Pricing")}
      </ListItem>

      {props.hidden === "Mileage" ? "" :
        <div>
          <ListItem>
            <div>
              <h3>Mileage</h3>
            </div>
          </ListItem>
          <ListItem>
            <div className="manualPricing">Original Grounding Mileage</div>
            <div className="manualPricing" style={{ color: '#e02020' }}>
              {InspectionVehicleDetails && InspectionVehicleDetails?.grounding_mileage && `${milesFormatter.format(InspectionVehicleDetails?.grounding_mileage)} MI`}
            </div>
          </ListItem>
          <ListItem>
            <p className="manualPricing">Inspection Mileage</p>
            <p className="manualPricing">
              {InspectionVehicleDetails &&
                InspectionVehicleDetails?.inspection_mileage && `${milesFormatter.format(InspectionVehicleDetails?.inspection_mileage)} MI`}
            </p>
          </ListItem>
          <ListItem>
            <div className="manualPricing">Updated Grounding Mileage</div>
            <div className="manualPricing">
              {InspectionVehicleDetails && InspectionVehicleDetails?.adjMileage && `${milesFormatter.format(InspectionVehicleDetails?.adjMileage)} MI`}
            </div>
          </ListItem>
          <ListItem>
            <FormControl className="mileageFomrControl">
              <div className="manualPricing manualLabel">Update Grounding Mileage</div>
              <BootstrapInput
                onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                placeholder="Enter Grounding Mileage"
                id="EntermarketPrice-input"
                name="groundingMileage"
                value={mileageForm.groundingMileage}
                onChange={handleOnChangeMileage}
              />
            </FormControl>
          </ListItem>
          <ListItem>
            <FormControl className="mileageFomrControl">
              <div className="manualPricing manualLabel">Confirm Grounding Mileage</div>
              <BootstrapInput
                onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                placeholder="Enter Confirm Grounding Mileage"
                id="reEntermarketPrice-input"
                name="confirmGroundingMileage"
                value={mileageForm.confirmGroundingMileage}
                onChange={handleOnChangeMileage}
                borderColor={"red"}
              />
              {mileageForm.hasErr &&
                mileageForm.groundingMileage !==
                mileageForm.confirmGroundingMileage ? (
                <Box color={"red"} fontSize={12}>
                  Confirm Grounding Mileage Does Not Match
                </Box>
              ) : (
                ""
              )}
            </FormControl>
          </ListItem>
          <ListItem className="reasonUpdate">
            <InputLabel className="updateMileageReasonHeading manualLabel">Reason for Update</InputLabel>
            <FormControl variant="outlined" className="mileageFomrControl updateMileageReason">
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={userUpdateMileageReason}
                name="reasonForUpdate"
                onChange={handleUpdateReason}
                onOpen={() => updateCheckBox(false)}
                onClose={() => updateCheckBox(true)}
                position='bottom'
              >
                {updateMileageReason.map((reason) => (
                  <MenuItem key={reason} value={reason}>
                    <div className={userUpdateMileageReason && userUpdateMileageReason?.indexOf(reason) > -1 ? 'selectedReason' : 'unselectedReason'}>
                      {!hideCheckBox && userUpdateMileageReason && userUpdateMileageReason?.indexOf(reason) > -1 && <CheckIcon style={{ color: 'red' }} />}
                    </div>
                    <ListItemText className="reasonText" primary={reason} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {userUpdateMileageReason?.includes('Other') && <BootstrapInput
              placeholder="Other Reason"
              id="other-reason"
              name="otherReason"
              value={mileageForm.otherReason}
              onChange={handleOnChangeMileage}
              borderColor={"red"}
              style={{ marginTop: '1rem', width: '100%' }}
            />}
            {otherReasonError && <Box color={"red"} fontSize={12}>
              Enter Other Reason
            </Box>}
          </ListItem>
          <ListItem>
            {updateStatus === true && (
              <Alert variant="outlined" severity="success">
                Mileage updated successfully!
              </Alert>
            )}
            {updateStatus === false && (
              <Alert variant="outlined" severity="error">
                {updateMileageErrorMessage}
              </Alert>
            )}
          </ListItem>
        </div>
      }
      {props.hidden === "Pricing" ? "" :
        <>
          <>
            {isCompanyCar ? '' :
              <>
                <ListItem>
                  <div>
                    <h3>Pricing</h3>
                  </div>
                </ListItem>
                <ListItem>
                  <FormControl className="mileageFomrControl manualLabel">
                    <label shrink htmlFor="vin-input">
                      Price
                    </label>
                    <TextField
                      placeholder="Enter price"
                      id="EntermarketPrice-input"
                      name="vehicle_price"
                      value={vehiclePriceForm?.vehicle_price}
                      onChange={priceUpdate}
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                      variant="outlined"
                    />
                  </FormControl>
                </ListItem>
                <ListItem>
                  <FormControl className="mileageFomrControl manualLabel">
                    <label shrink htmlFor="vin-input">
                      Re-Enter Market Price
                    </label>
                    <TextField
                      placeholder="Enter Confirm Price"
                      id="reEntermarketPrice-input"
                      name="confirm_vehicle_price"
                      value={vehiclePriceForm?.confirm_vehicle_price}
                      onChange={handleOnReEnterChangeVehiclePrice}
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                      variant="outlined"
                    />
                    {vehiclePriceForm.hasErr &&
                      vehiclePriceForm.vehicle_price !==
                      vehiclePriceForm.confirm_vehicle_price ? (
                      <Box color={"red"} fontSize={12}>
                        Confirm Price Does Not Match
                      </Box>
                    ) : (
                      ""
                    )}
                  </FormControl>
                </ListItem>
                <ListItem>
                  <FormControl className="mileageFomrControl manualLabel">
                    <label shrink htmlFor="vin-input">
                      MMR
                    </label>
                    <TextField
                      placeholder="Enter MMR"
                      id="vin-input"
                      name="MMR"
                      value={vehiclePriceForm.MMR}
                      onChange={handleOnChangeVehiclePrice}
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                      variant="outlined"
                    />
                    {vehiclePriceForm.isMMRRequired ? (
                      <Box color={"red"} fontSize={12}>
                        MMR is Mandatory
                      </Box>
                    ) : (
                      ""
                    )}
                  </FormControl>
                </ListItem>
                <ListItem>
                  {updatePricingStatus === true && (
                    <Alert variant="outlined" severity="success">
                      Price updated successfully!
                    </Alert>
                  )}
                  {updatePricingStatus === false && (
                    <Alert variant="outlined" severity="error">
                      {updatePricingErrorMessage}
                    </Alert>
                  )}
                </ListItem>
              </>
            }
          </>
          <Divider variant="middle" />
          <div>
            <ListItem>
              <Box display={"flex"} alignItems={"center"} width={"100%"}>
                <Box className="manualPricing">TFS Carfax Alert Status:</Box>
                <Box pt={1}>
                  <FiberManualRecordIcon
                    style={{
                      color: clearFixStatus ? clearFixStatus : "#a9a9a9",
                    }}
                  />
                </Box>
              </Box>
            </ListItem>
            <ListItem>
              <p>Grounding Dealer State: {condionVehicleDetails?.location_state}</p>
            </ListItem>
            <Divider variant="middle" />
            <List className="swipeFilterBtn">
              <>
                {
                  isCompanyCar ? '' :
                    <Button
                      variant="outlined"
                      autoFocus
                      className="fullpricinghistorybtn"
                      color="primary"
                      onClick={() => {
                        setViewFullPricingHistoryPop(true);
                      }}
                    >
                      View Pricing History
                    </Button>
                }
              </>
            </List>
          </div>
        </>
      }

      <List className="swipeFilterBtn">
        <Button
          variant="outlined"
          autoFocus
          className="cancelButton"
          color="primary"
          onClick={() => resetForm(true, true)}
        >
          Reset
        </Button>
        <Button
          disabled={submitButtonValue}
          autoFocus
          variant="contained"
          className={submitButtonStyle}
          onClick={updateDetails}
        >
          Submit
        </Button>
      </List>

      {ViewFullPricingHistoryPop ?
        <ViewFullPricingHistory
          vin={vin}
          open={ViewFullPricingHistoryPop}
          onClose={() => {
            setViewFullPricingHistoryPop(false);
          }}
        ></ViewFullPricingHistory> : ""}

      {isCompanyCar ?
        <div style={{ margin: "20px 5px 15px 20px" }}>
          <Alert variant="outlined" severity="error" >This is a Company Car. We are unable to price company cars at this time.</Alert>
        </div> : ""
      }

    </div>
  );
}
